"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("../theme/utils");

var _default = {
  shared: function shared(theme) {
    return {
      width: '100%',
      height: '100%',
      borderRadius: '2px',
      border: "solid 1px ".concat(theme.palette.uiBorder),
      color: "".concat(theme.palette.text.input, " !important"),
      transition: theme.transition.create(),
      paddingLeft: theme.spacer(3),
      paddingRight: theme.spacer(3)
    };
  },
  focused: function focused(theme) {
    return {
      border: "solid 1px ".concat(theme.palette.primary["default"]),
      boxShadow: "0 1px 8px 0 ".concat((0, _utils.fade)(theme.palette.primary.hover, 0.5))
    };
  },
  hover: function hover(theme) {
    return {
      border: "solid 1px ".concat(theme.palette.primary["default"])
    };
  },
  error: function error(theme) {
    return {
      backgroundColor: theme.palette.error.background,
      border: "solid 1px ".concat(theme.palette.error["default"], " !important"),
      boxShadow: 'none !important'
    };
  },
  disabled: function disabled(theme) {
    return {
      cursor: 'not-allowed',
      color: "".concat(theme.palette.disabledText, " !important"),
      backgroundColor: theme.palette.disabledBackground,
      '&:hover': {
        border: "solid 1px ".concat(theme.palette.border),
        boxShadow: 'none'
      }
    };
  },
  placeholder: function placeholder(theme) {
    return {
      color: theme.palette.text.secondaryText
    };
  }
};
exports["default"] = _default;